import { Action, createReducer, on } from '@ngrx/store';
import { IBenchmark } from '../models/benckmark.model';
import * as fromSearchBenchmarksActions from '../actions';

export const searchBenchmarksFeatureKey = 'searchBenchmarks';

export interface State {
  loaded: boolean;
  error?: Error | any;
  searchBenchmarks: IBenchmark[];
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  searchBenchmarks: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    fromSearchBenchmarksActions.loadSearchBenchmarks,

    state => state
  ),
  on(fromSearchBenchmarksActions.loadSearchBenchmarksSuccess, (state, action) => ({
    ...state,
    searchBenchmarks: action.response,
    loaded: true
  })),

  on(fromSearchBenchmarksActions.loadSearchBenchmarksFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectSearchBenchmarks = (state: State) => state.searchBenchmarks;
export const selectSearchBenchmarksLoaded = (state: State) => state.loaded;
export const selectSearchBenchmarksError = (state: State) => state.error;
